import React from 'react';
import { Link } from 'react-router-dom';

const InsuranceContractList = ({ contracts, loading }) => {
  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>Contract ID</th>
            <th>User ID</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Sub ID</th>
            <th>Carrier</th>
            <th>Status</th>
            <th>Updated Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {contracts.length === 0 && !loading && (
            <tr>
              <td colSpan="9">No contracts found</td>
            </tr>
          )}
          {contracts.length > 0 &&
            contracts.map((contract) => (
              <tr key={contract.id}>
                <td>{contract.id}</td>
                <td>{contract.user_profile}</td>
                <td>{contract.first_name}</td>
                <td>{contract.last_name}</td>
                <td>
                  {contract.subscription ||
                    contract.att_subscription ||
                    contract.tracfone_subscription ||
                    contract.simo_subscription ||
                    contract.quick_subscription}
                </td>
                <td>
                  {contract.subscription && 'Sprint'}
                  {contract.att_subscription && 'AT&T'}
                  {contract.tracfone_subscription && 'Tracfone'}
                  {contract.simo_subscription && 'Simo'}
                  {contract.quick_subscription && 'Quick'}
                </td>
                <td>{contract.status}</td>
                <td>{contract.updated_at}</td>
                <td>
                  <Link to={`/device-protection/contracts/${contract.id}/view`}>
                    View
                  </Link>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default InsuranceContractList;
